import type { StrictMerge } from '@noths/polaris-dev-ts-recipes';

export type DeliveryByEventName =
  | 'valentines_day'
  | 'mothers_day'
  | 'easter'
  | 'fathers_day'
  | 'halloween'
  | 'christmas';

export const deliveryByEventNamesMap: Record<DeliveryByEventName, undefined> = {
  valentines_day: undefined,
  mothers_day: undefined,
  easter: undefined,
  fathers_day: undefined,
  halloween: undefined,
  christmas: undefined,
};

export const deliveryByEventNames = Object.keys(deliveryByEventNamesMap);

interface DeliveryByEventAttrs {
  name: string;
  prefix: 'Get' | 'Arrives';
}

export type DeliveryByEventDisplayNames = StrictMerge<
  Record<DeliveryByEventName, DeliveryByEventAttrs>,
  {
    christmas: {
      name: 'Christmas';
      prefix: 'Arrives';
    };
    easter: {
      name: 'Easter';
      prefix: 'Get';
    };
    fathers_day: {
      name: "Father's day";
      prefix: 'Get';
    };
    halloween: {
      name: 'Halloween';
      prefix: 'Get';
    };
    mothers_day: {
      name: "Mother's day";
      prefix: 'Get';
    };
    valentines_day: {
      name: "Valentine's day";
      prefix: 'Get';
    };
  }
>;

export type DeliveryByEventDisplayName =
  DeliveryByEventDisplayNames[keyof DeliveryByEventDisplayNames];

export interface DeliveryByEvent {
  arriveByEvent: boolean;
  eventName: DeliveryByEventName;
  lastDeliveryBy: string;
}
